module.exports = __webpack_public_path__ + "img/image 04.9ba4fa30.png";